import { GEOMETRY_TYPE } from '@tmapy/config';
export const getSimpleGeometryType = (type) => {
    switch (type) {
        case GEOMETRY_TYPE.TEXT:
        case GEOMETRY_TYPE.POINT:
        case GEOMETRY_TYPE.MULTI_POINT:
            return GEOMETRY_TYPE.POINT;
        case GEOMETRY_TYPE.LINE_STRING:
        case GEOMETRY_TYPE.MULTI_LINE_STRING:
            return GEOMETRY_TYPE.LINE_STRING;
        case GEOMETRY_TYPE.POLYGON:
        case GEOMETRY_TYPE.MULTI_POLYGON:
            return GEOMETRY_TYPE.POLYGON;
        case GEOMETRY_TYPE.BOX:
            return GEOMETRY_TYPE.BOX;
        default:
            return type;
    }
};
//# sourceMappingURL=getSimpleGeometryType.js.map